<template>
    <div class="xxy-upload">
        <div class="tooltip" style="height:150px">
            <div class="thumbnail" v-if="defaultUrl && !isVideo">
                <img :src="defaultUrl" v-if="!isVideo" style="width: 160px"/>
                <!--<img src="/static/image/video.png" v-if="defaultUrl && isVideo">-->
                <div class="bg">
                    <div class="previewImg" @click="previewImg(item)">预览</div>
                    <div class="line-1"></div>
                    <div class="deleteImg" @click="deleteImg(index)">删除</div>
                </div>
            </div>
            <div class="d" v-if="defaultUrl && isVideo">
                <video height="160px" width="285px" poster :src="defaultUrl"></video>
                <div class="bg">
                    <div class="deleteImg" @click="deleteImg()">删除</div>
                    <div class="line-1"></div>
                    <div class="previewImg" @click="previewVideo()">预览</div>
                </div>
            </div>

            <!--测试-->
            <el-upload
                    v-show="!defaultUrl || isText"
                    ref="dom_upload"
                    :list-type="listType"
                    :auto-upload="false"
                    :on-success="uploadHandle"
                    :on-error="errorHandle"
                    :on-preview="handlePictureCardPreview"
                    :on-change="changeHandle"
                    :on-remove="handleRemove"
                    action="https://up.qiniup.com"
                    :data="data"
                    :limit="1"
                    :accept="accept"
                    :show-file-list="false">
                <!--正式-->
                <!--<el-upload
                        v-show="!defaultUrl || isText"
                        ref="dom_upload"
                        :list-type="listType"
                        :auto-upload="false"
                        :on-success="uploadHandle"
                        :on-error="errorHandle"
                        :on-preview="handlePictureCardPreview"
                        :on-change="changeHandle"
                        :on-remove="handleRemove"
                        action="https://up-z2.qiniup.com"
                        :data="data"
                        :limit="1"
                        :accept="accept"
                        :show-file-list="false">-->
                <i slot="default" class="el-icon-plus"></i>
            </el-upload>
        </div>
        <!-- 预览头像 -->
        <el-dialog :visible.sync="isShowImg" :append-to-body="true" title="预览" custom-class="preview-img" class="agent">
            <img width="100%" :src="showImgSrc" alt/>
        </el-dialog>
    </div>
</template>
<script>
    import config from "@/assets/js/config";
    import {uptoken11111} from "@/assets/js/api";


    export default {
        name: 'FileUpload',
        props: {
            requirement: {
                type: String,
                default: "无"
            },
            defaultUrl: {
                type: String,
                default: null
            },
            isVideo: {
                type: Boolean,
                default: false
            },
            isText: {
                type: Boolean,
                default: false
            }
        },
        data: () => ({
            disabled: false,
            limitCount: 1,
            data: {
                token: ""
            },
            callback: null,
            isShowImg: false,
            showImgSrc: '',
            loading: null
        }),
        computed: {
            listType() {
                return this.isText ? "list-text" : "picture-card";
            },
            accept() {
                return this.isVideo ? "video/*" : "image/*";
            }
        },
        created() {
            // console.log(this.defaultUrl)
            // console.log(11111)
        },
        mounted() {
            this.$nextTick(() => {
                this.$refs.dom_upload && this.$refs.dom_upload.clearFiles();
                //  console.log( this.$refs.dom_upload)

            });
        },
        methods: {
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },

            action() {
                return location.origin === 'http://bdwinningweb.yinchtv.com' ? 'https://up-z2.qiniup.com' : 'http://up-z2.qiniu.com'
            },
            getuptoken() {
                //发起请求获取token
                uptoken11111().then(res => {
                    console.log('11111111111111111111111111111111111'+res)
                    return res.data.Data[0].Token
                })
            },
            startupload(cb) {
                let that = this;
                let up = that.$refs.dom_upload;
                this.callback = cb;
                if (up && up.uploadFiles.length > 0 && !up.uploadFiles[0].response) {
                    that.loading = this.$loading({
                        lock: true,
                        text: "文件上传中...",
                        customClass: "full-loading"
                    });
                    uptoken11111().then(res => {
                        console.log('22222222222222222222222222222222222'+res.data.uploadToken)
                        that.data.token = res.data.uploadToken
                        that.$refs.dom_upload.submit();
                    })
                } else {
                    cb();
                }
            },
            uploadHandle(response, file, fileList) {
                this.$refs.dom_upload && this.$refs.dom_upload.clearFiles();
            },

            errorHandle(err, file, fileList) {
                // console.log(err, file, fileList);
                this.$refs.dom_upload && this.$refs.dom_upload.clearFiles();
            },
            changeHandle(e, fileList) {
                let _this = this;
                if (this.loading) this.loading.close();
                let url = "";
                let img = new Image();
                if (e.response) {
                    url = config.qiniu.bucketHost + e.response.key;
                    // url = 'http://xcxqn.chindee.com/' + e.response.key;
                    if (
                        (e.raw.type === "image/jpeg" || e.raw.type === "image/png") &&
                        e.raw.size >= 2097152
                    ) {
                        img.src = url + "?imageView2/2/w/10";
                        img.onload = function () {
                            console.log(img);
                            console.log(img.width + "宽=====高" + img.height);
                            if (img.width > img.height) {
                                console.log("宽大");
                                url = url + "?imageView2/2/w/1024";
                            } else {
                                console.log("高大");
                                url = url + "?imageView2/2/h/1024";
                            }
                            console.log("137", url);
                            _this.$emit("update:defaultUrl", url);
                            _this.callback && _this.callback();
                        };
                    } else {
                        console.log("142", url);
                        _this.$emit("update:defaultUrl", url);
                        _this.callback && _this.callback();
                    }
                    this.$refs.dom_upload && this.$refs.dom_upload.clearFiles();
                } else {
                    // console.log(e.raw.type)
                    // if (e.raw.type.indexOf('image') === -1) {
                    //     // console.log(1111)
                    //     this.$refs.dom_upload.uploadFiles.pop()
                    // }else{
                    url = e.url;
                    this.$emit("update:defaultUrl", url);
                    this.callback && this.callback();
                    // }

                }
            },
            handleRemove(file) {
                this.$refs.dom_upload.clearFiles();
                this.$emit("update:defaultUrl", "");
            },
            previewImg() {
                if (this.isVideo) {
                    window.open(this.defaultUrl, "_blank");
                } else {
                    this.showImgSrc = this.defaultUrl;
                    this.isShowImg = true;
                }
            },
            deleteImg() {
                this.$refs.dom_upload.clearFiles();
                this.$emit("update:defaultUrl", "");
            },
            previewVideo() {
                if (this.defaultUrl) {
                    window.open(this.defaultUrl, '_blank')
                } else {
                    this.$message({
                        type: 'error',
                        message: '资源不存在！',
                        duration: 5000,
                        onClose: ''
                    })
                }
            },
            clearFiles() {
                this.$refs.dom_upload.clearFiles();
            }
        }
    };
</script>
<!--<style>-->
<!--.thumbnail {-->
<!--width: 148px;-->
<!--height: 148px;-->
<!--border: 1px solid #f0f0f0;-->
<!--border-radius: 5px;-->
<!--text-align: center;-->
<!--position: relative;-->
<!--overflow: hidden;-->
<!--}-->
<!--.thumbnail img {-->
<!--width: 100%;-->
<!--display: block;-->
<!--}-->
<!--.bg {-->
<!--display: none;-->
<!--position: absolute;-->
<!--background-color: rgba(0, 0, 0, 0.5);-->
<!--bottom: 0px;-->
<!--left: 0px;-->
<!--width: 148px;-->
<!--height: 36px;-->
<!--justify-content: space-around;-->
<!--align-items: center;-->
<!--border-radius: 5px;-->
<!--}-->

<!--.previewImg {-->
<!--cursor: pointer;-->
<!--margin-left: 20px;-->
<!--font-size: 14px;-->
<!--font-family: PingFangSC-Regular, PingFang SC;-->
<!--font-weight: 400;-->
<!--color: #FFFFFF;-->
<!--}-->
<!--.thumbnail:hover .bg {-->
<!--display: inline-flex;-->
<!--}-->
<!--.deleteImg {-->
<!--cursor: pointer;-->
<!--margin-right: 20px;-->
<!--font-size: 14px;-->
<!--font-family: PingFangSC-Regular, PingFang SC;-->
<!--font-weight: 400;-->
<!--color: #FFFFFF;-->
<!--}-->
<!--</style>-->
<style lang="scss" scoped>
    .xxy-upload {
        margin: 5px 0;
    }

    .tooltip {
        width: 285px;
        height: 160px;
    }

    .thumbnail {
        width: 160px;
        height: 160px;
        border: 1px solid #f0f0f0;
        border-radius: 5px;
        text-align: center;
        position: relative;
        overflow: hidden;

        img {
            width: 100%;
            display: block;
        }

        .bg {
            display: none;
            position: absolute;
            background-color: rgba(0, 0, 0, 0.5);
            bottom: 0px;
            left: 0px;
            width: 160px;
            height: 36px;
            justify-content: space-around;
            align-items: center;
            border-radius: 5px;
        }
        &:hover {
            .bg {
                display: inline-flex;

                .previewImg {
                    cursor: pointer;
                    margin-left: 20px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FFFFFF;
                }
                .deleteImg {
                    cursor: pointer;
                    margin-right: 20px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FFFFFF;
                }
            }
        }
        .line-1 {
            height: 14px;
            width: 2px;
            background-color: #FFFFFF;
        }
    }

    .d {
        width: 285px;
        height: 160px;
        border: 1px solid #f0f0f0;
        border-radius: 5px;
        text-align: center;
        position: relative;
        overflow: hidden;

        img {
            width: 100%;
            display: block;
        }

        .bg {
            display: none;
            position: absolute;
            background-color: rgba(0, 0, 0, 0.5);
            bottom: 0px;
            left: 0px;
            width: 285px;
            height: 36px;
            justify-content: space-around;
            align-items: center;
            border-radius: 5px;
        }

        &:hover {
            .bg {
                display: inline-flex;

                .previewImg {
                    cursor: pointer;
                    margin-left: 20px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FFFFFF;
                }

                .deleteImg {
                    cursor: pointer;
                    margin-right: 20px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FFFFFF;
                }
            }
        }

        .line-1 {
            height: 14px;
            width: 2px;
            background-color: #FFFFFF;
        }
    }

    /*.d .deleteImg {*/
    /*display: none;*/
    /*position: absolute;*/
    /*bottom: 0px;*/
    /*left: 0px;*/
    /*background-color: rgba(0, 0, 0, 0.5);*/
    /*color: #FFFFFF;*/
    /*width: 285px;*/
    /*height: 36px;*/
    /*text-align: center;*/
    /*border-radius: 5px;*/
    /*cursor: pointer;*/
    /*}*/

    /*.d {*/
    /*position: relative;*/
    /*border: 1px solid #f0f0f0;*/
    /*width: 285px;*/
    /*height: 160px;*/
    /*margin: auto;*/
    /*}*/

    /*.d:hover .deleteImg {*/
    /*display: inline;*/
    /*}*/

    .my-upload {
        width: 285px;
        height: 160px;
    }

    .el-upload__text {
        margin: -80px auto;
        width: 190px;
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFangSC;
        color: #999999;
        font-weight: 500;
        line-height: 22px;
    }

    .el-upload__tip {
        margin: 95px auto;
        width: 255px;
        height: 40px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFangSC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 18px;
    }

    .el-icon-upload:hover {
        color: #409EFF;
    }

    .my-upload .el-upload--picture-card i {
        font-size: 28.5px;
        color: #8c939d;
        position: relative;
        top: -20px;
        border: 0px;
    }

    .el-upload-dragger {
        width: 285px;
        height: 160px;
    }

    .agent .el-icon-close:before {
        content: "\e6db" !important;
    }

</style>
